import { render } from "./footerComp.vue?vue&type=template&id=6d9e7772&scoped=true"
import script from "./footerComp.vue?vue&type=script&lang=js"
export * from "./footerComp.vue?vue&type=script&lang=js"

import "./footerComp.vue?vue&type=style&index=0&id=6d9e7772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9e7772"]])

export default __exports__